import { useEffect, useState } from "react";
import { EVENT_START } from "@/lib/content";

const calc = () => {
  const ms = Math.max(0, EVENT_START.getTime() - Date.now());
  return { d: Math.floor(ms / 864e5), h: Math.floor((ms / 36e5) % 24), m: Math.floor((ms / 6e4) % 60), s: Math.floor((ms / 1e3) % 60) };
};

const Cell = ({ v, label, id }) => (
  <div className="flex min-w-[64px] flex-col items-center rounded-xl border border-line bg-ink2/80 px-3 py-3 sm:min-w-[76px]">
    <span data-testid={`countdown-${id}`} className="font-serif text-3xl font-semibold lining-nums tabular-nums text-gold-light sm:text-4xl">
      {String(v).padStart(2, "0")}
    </span>
    <small className="mt-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-sand">{label}</small>
  </div>
);

export const Countdown = () => {
  const [t, setT] = useState(calc);
  useEffect(() => {
    const i = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(i);
  }, []);
  return (
    <div className="flex gap-2 sm:gap-3" aria-label="Tempo alla prima serata" data-testid="countdown">
      <Cell v={t.d} label="giorni" id="days" />
      <Cell v={t.h} label="ore" id="hours" />
      <Cell v={t.m} label="minuti" id="minutes" />
      <Cell v={t.s} label="secondi" id="seconds" />
    </div>
  );
};
